import { ref } from '@nuxtjs/composition-api';
const isWriteReviewDrawerOpen = ref(false);

export default function useWriteReviewDrawerOpener() {
  const toggleWriteReviewDrawer = (newValue) => {
    isWriteReviewDrawerOpen.value = newValue;
  };

  return {
    isWriteReviewDrawerOpen,
    toggleWriteReviewDrawer
  };
}
